import {useQuery} from 'react-query';

import getCommentsList from '.';

const useGetCommentsList = (guid?: string) => {
  const {data, isLoading, refetch} = useQuery(
    ['get-buyers-list', guid],
    getCommentsList,
  );

  return {
    commentsList: data,
    commentsListIsLoading: isLoading,
    refetchAllComments: refetch,
  };
};

export default useGetCommentsList;
